import React, { useEffect, useState } from "react";
import ResourcesManagerTabs from "../../components/ResourcesManagerTabs/ResourcesManagerTabs";
import { ContentContainer, GeneralStyle } from "./ResourcesContainer.styled";
import ContentTabOfResources from "../../components/ContentTabOfResources/ContentTabOfResources";
import { RESOURCE_LIST_BY_MODULE } from "../../GraphQL/Queries";
import { useLazyQuery } from "@apollo/client";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { NotificationManager } from "react-notifications";
import {
  uploadUserGuide,
  getUserGuide,
} from "../../services/UserGuideFileManager";

const ResourcesContainer = () => {
  const [selectMenu, setSelectMenu] = useState(["AboutWellness"]);
  const [userLoggedIn] = useState(getStateLoginComplete());
  const [valueTabs, setValueTabs] = useState(0);
  const [searchTxt, setSearchTxt] = useState("");
  const [files, setFiles] = useState([]);
  const [showLoader, setShowLoader] = useState();
  const [renderAgain, setRenderAgain] = useState(false);
  const [runQueryGetResourceByModuleId] = useLazyQuery(
    RESOURCE_LIST_BY_MODULE,
    {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        if (data?.resourceListByModule)
          setFiles([...data.resourceListByModule]);
        setShowLoader(false);
      },
    }
  );

  const handleUploadFile = (file, resourceType) => {
    if (file?.type === "application/pdf") {
      //let reader = new FileReader()
      //let fileBase64 = reader.readAsDataURL(file)
      setShowLoader(true);
      uploadUserGuide(file, selectMenu, resourceType)
        .then((response) => {
          NotificationManager.success(response, "", 5000);
          setRenderAgain(!renderAgain);
          setShowLoader(false);
        })
        .catch((error) => {
          NotificationManager.error(error.message, "", 5000);

          setShowLoader(false);
        });
    } else {
      NotificationManager.warning("Please upload a pdf file", "", 5000);
    }
  };

  const handleDownloadFile = (fileName) => {
    if (fileName) {
      getUserGuide(fileName);
    }
  };

  useEffect(() => {
    setShowLoader(true);
    runQueryGetResourceByModuleId({
      variables: {
        categoryName: selectMenu[0],
      },
      context: { clientName: "LinkUsers" },
    });
    setFiles([]);
  }, [selectMenu[0], renderAgain]);

  return (
    <GeneralStyle>
      <ResourcesManagerTabs
        setSelectMenu={setSelectMenu}
        setValueTabs={setValueTabs}
        valueTabs={valueTabs}
        searchTxt={searchTxt}
        setSearchTxt={setSearchTxt}
        renderAgain={renderAgain}
        setrenderAgain={setRenderAgain}
      />
      <hr />
      <ContentContainer>
        <ContentTabOfResources
          handleUploadFile={handleUploadFile}
          files={files}
          userLoggedIn={userLoggedIn}
          handleDownloadFile={handleDownloadFile}
          tabSelected={selectMenu[0]}
        />
      </ContentContainer>
      {showLoader && <ModalLoader />}
    </GeneralStyle>
  );
};

export default ResourcesContainer;
